import React from "react";
import { mergeStyleSets } from "@fluentui/react";
import { eachDayOfInterval, endOfMonth, format, getDay } from "date-fns";
import { STATUS, STATUS_LABELS, toKey } from "./streakUtils";

const WEEKDAYS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

export const CELL_COLORS = {
    [STATUS.COMPLETED]: { background: "#1e6fd9", color: "#fff" },
    [STATUS.PATCHED]: { background: "#8a3ffc", color: "#fff" },
    [STATUS.MISSED]: { background: "#d13438", color: "#fff" },
    [STATUS.IN_PROGRESS]: { background: "#fff", color: "#1e6fd9", border: "2px solid #1e6fd9" },
    outOfRange: { background: "transparent", color: "#a19f9d" },
    future: { background: "#f3f2f1", color: "#a19f9d" },
};

const classes = mergeStyleSets({
    month: {
        border: "1px solid #c8c6c4",
        borderRadius: 4,
        overflow: "hidden",
        background: "#faf9f8",
    },
    title: {
        textAlign: "center",
        fontSize: 18,
        fontWeight: 600,
        padding: "6px 0",
        background: "#edebe9",
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(7, 1fr)",
        gap: 3,
        padding: 6,
    },
    weekday: {
        textAlign: "center",
        fontWeight: 600,
        fontSize: 12,
        color: "#605e5c",
    },
    cell: {
        height: 30,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 4,
        fontSize: 13,
        boxSizing: "border-box",
        border: "none",
        padding: 0,
        font: "inherit",
    },
    clickable: {
        cursor: "pointer",
        selectors: { ":hover": { outline: "2px solid #323130", outlineOffset: 1 } },
    },
});

const CLICKABLE = [STATUS.COMPLETED, STATUS.PATCHED, STATUS.MISSED];

const StreakMonth = ({ monthStart, dayMap, today, onSelectPeriod }) => {
    const days = eachDayOfInterval({ start: monthStart, end: endOfMonth(monthStart) });
    const leadingBlanks = getDay(monthStart);

    return (
        <div className={classes.month}>
            <div className={classes.title}>{format(monthStart, "MMMM")}</div>
            <div className={classes.grid}>
                {WEEKDAYS.map((weekday) => (
                    <div key={weekday} className={classes.weekday}>{weekday}</div>
                ))}
                {Array.from({ length: leadingBlanks }).map((_, i) => (
                    <div key={`blank-${i}`} />
                ))}
                {days.map((day) => {
                    const key = toKey(day);
                    const period = dayMap.get(key);
                    const state = !period ? "outOfRange" : key > today ? "future" : period.status;
                    const isClickable = CLICKABLE.includes(state);
                    const label = state === "outOfRange" ? "Outside streak" : state === "future" ? "Future" : STATUS_LABELS[state];

                    if (!isClickable) {
                        return (
                            <div key={key} className={classes.cell} style={CELL_COLORS[state]} title={`${key}: ${label}`}>
                                {day.getDate()}
                            </div>
                        );
                    }

                    return (
                        <button
                            type="button"
                            key={key}
                            className={`${classes.cell} ${classes.clickable}`}
                            style={CELL_COLORS[state]}
                            title={`${key}: ${label}${period.activityCount ? ` (${period.activityCount} activities)` : ""}`}
                            onClick={() => onSelectPeriod(period)}
                        >
                            {day.getDate()}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default StreakMonth;
